import { pathOr } from 'ramda';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import {
  SET_CENTRIFUGO_CONNECTED,
  SET_CENTRIFUGO_DISCONNECTED,
  SET_CENTRIFUGO_ERROR,
} from '../../../constants/centrifugo';
import { CENTRIFUGO_STATUS, PROJECTS } from '../../../../constants/centrifugo';
import { personalChannelReducer } from './personal';
import type { RootState } from '../../../store';

export interface CentrifugoState {
  status: CENTRIFUGO_STATUS;
}

export const initialState: CentrifugoState = {
  status: CENTRIFUGO_STATUS.INIT,
};

export const stateReducer = (
  state = initialState,
  action: { type: string }
): CentrifugoState => {
  switch (action.type) {
    case SET_CENTRIFUGO_CONNECTED: {
      return {
        ...state,
        status: CENTRIFUGO_STATUS.SUCCESS,
      };
    }

    case SET_CENTRIFUGO_DISCONNECTED: {
      return {
        ...state,
        status: CENTRIFUGO_STATUS.ERROR,
      };
    }

    case SET_CENTRIFUGO_ERROR: {
      return {
        ...state,
        status: CENTRIFUGO_STATUS.ERROR,
      };
    }

    default: {
      return state;
    }
  }
};

export const centrifugoSelector = (state: RootState) =>
  pathOr(initialState, ['domain', 'centrifugo', 'states'], state);

export const isCentrifugoConnectedSelector = createSelector(
  centrifugoSelector,
  (state) => state.status === CENTRIFUGO_STATUS.SUCCESS
);

export const isCentrifugoErrorSelector = createSelector(
  centrifugoSelector,
  (state) => state.status === CENTRIFUGO_STATUS.ERROR
);

export default combineReducers({
  states: stateReducer,
  [PROJECTS.PERSONAL]: personalChannelReducer,
});
